import React from "react";
import Form from "ui/Form";
import styled from "styled-components/macro";

// The Size type of Form.Control isn't the same as the Size type of an input element
export type Props = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "size"
> & {
  "data-testid"?: string;
  value?: string;
  inputRef?: React.Ref<HTMLInputElement>;
};

const $Input = styled.input`
  border-radius: 4px;
  height: 3.5rem;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.ColorSneaker300};
  &:focus {
    border: 1px solid ${({ theme }) => theme.ColorBlurple500};
    box-shadow: 0 0 5px ${({ theme }) => theme.ColorBlurple500};
  }
  &::placeholder {
    color: ${({ theme }) => theme.ColorSneaker300};
  }
  &[aria-invalid="true"] {
    border: 2px solid ${({ theme }) => theme.ColorEraserRed200};
    color: ${({ theme }) => theme.ColorEraserRed300};
  }
`;

export default function Input({
  "data-testid": dataTestId,
  value,
  inputRef,
  ...rest
}: Props) {
  return (
    <Form.Control
      as={$Input}
      ref={inputRef}
      data-testid={dataTestId}
      value={value}
      {...rest}
    />
  );
}
